import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaArrowRight, FaRegCopy } from 'react-icons/fa';
import '../styles/AiChat.css';

function AiChat() {
  const API_BASE_URL = process.env.REACT_APP_API_URL;
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);


  useEffect(() => {
    const token = localStorage.getItem("userToken");
    // بررسی وجود توکن
    setIsLoggedIn(!!token);
  }, []);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const userMessage = { text: input, sender: 'user' };
    setMessages((prev) => [...prev, userMessage]);
    

    try {
      const token = localStorage.getItem("userToken");
      // 🟢 درخواست به API هوش مصنوعی (نمونه)
      const response = await fetch(`${API_BASE_URL}/AI/chat`, {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // ارسال توکن برای احراز هویت
        },
        body: JSON.stringify({ Text: input }),
      });

      const data = await response.json();
      setInput('');
      const aiMessage = { text: data.response, sender: 'ai' };

      setMessages((prev) => [...prev, aiMessage]);
    } catch (error) {
      console.error('Error receiving response:', error);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert('Text copied!');
  };

  if (!isLoggedIn) {
    return (
      <motion.div
        className="chat-page"
        initial={{ opacity: 0, x: -30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.9, ease: 'easeOut' }}
      >
        <h2>Please Login First</h2>
      </motion.div>
    );
  }

  return (
    <motion.div
      className="chat-page"
      initial={{ opacity: 0, x: -30 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.9, ease: 'easeOut' }}
    >
      <h1>Chat with Legion</h1>

      <div className="chat-container">
        {messages.map((msg, index) => (
          <div key={index} className={`message ${msg.sender}`}>
            <p>{msg.text}</p>
            {msg.sender === 'ai' && (
              <button className="copy-btn" onClick={() => copyToClipboard(msg.text)}>
                <FaRegCopy />
              </button>
            )}
          </div>
        ))}
      </div>

      <p className="warning-text">📌 If there is important information in the chat, be sure to make a copy of it!</p>

      <div className="input-container">
        <textarea
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKeyDown}
          placeholder="Type your message..."
        />
        <button onClick={sendMessage} className="send-btn">
          <FaArrowRight />
        </button>
      </div>
    </motion.div>
  );
}

export default AiChat;
